export const REWARD_TYPES = {
  0: "LoginStreak",
  1: "ReferAFriendReferrEE",
  2: "ReferAFriendReferrER",
  3: "Clash",
  4: "FreeCoinPack",
  5: "DailyLogin",
  6: "ReadNoteFromCommissioner",
  7: "DailyContestEntered",
  8: "OpenFreeLoginPack",
  9: "GenerateReportCard",
  10: "QuickSellCard",
  11: "FriendReferral",
  12: "PlayPick2Win",
  13: "SellCard",
  14: "BuyCard",
  15: "OpenGoldPack",
  16: "OpenSilverPack",
  17: "OpenBasePack",
  18: "OpenLWPack",
  19: "OpenRWPack",
  20: "OpenCPack",
  21: "OpenDPack",
  22: "OpenPromoPack",
  23: "OpenPlayoffPack",
  24: "TrainBronzeSlot",
  25: "TrainSilverSlot",
  26: "TrainGoldSlot",
  27: "BuyCoinBundle01",
  28: "BuyCoinBundle02",
  29: "BuyCoinBundle03",
  30: "BuyCoinBundle04",
  31: "BuyCoinBundle05",
  32: "BuyCoinBundle06",
  33: "BuyMegaSpin",
  34: "BuySuperSpin",
  35: "CompleteTutorial",
  36: "AllAccessPass",
  37: "DivisionPromotion",
  38: "Adjustment",
};
